import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { editCover, setConfirmDeleteMember } from '@om/redux/actions/easiplusFuneralPlan/quote';
import { OmLabeledValueSummary, OmEfpFamilyMemberCard, OmLabeledValue } from '@om/component-library-react';
import { getValueWithThousandSeperator } from '@om/redux/selectors/sizotsaFuneralCover/quote';
import { createStructuredSelector } from 'reselect';
import { getActivePageIndex } from '@om/redux/selectors/sizotsaFuneralCover/routing';

const SizotsaFamilyMemberCard = ({
    id,
    relationship,
    age,
    coverAmount,
    name,
    monthlyPremium,
    category,
    incomeStabilization,
    onDelete,
    deleteEnabled = false,
    onEdit,
    editEnabled = true
}) => {
    const dispatch = useDispatch();

    const {
        activePageIndex,
    } = useSelector(
        createStructuredSelector({
            activePageIndex: getActivePageIndex,
        })
    );
    return (
        <OmEfpFamilyMemberCard
            expanded
            editEnabled={editEnabled}
            deleteEnabled={deleteEnabled}
            addDetailsEnabled
            cardId={id}
            onEditDetailsClicked={onEdit}
            onPopupModal={onDelete}
        >
            <h6 className="strong small no-top-margin no-bottom-margin" slot="family-member-card-heading">
                {relationship}
            </h6>
            <div style={{display:'flex',gap:'5px', padding:'0 0 0 10px', justifyContent:'space-between', width:'calc(120% - 120px)'}} slot="family-member-card-body">
                {activePageIndex == 2 && <OmLabeledValueSummary label="Name" value={name ?? '-'} />}
                <OmLabeledValueSummary label="AGE" value={age} />
                <OmLabeledValueSummary label="COVER AMOUNT" value={'E ' + getValueWithThousandSeperator(+coverAmount)} />
               {incomeStabilization &&<OmLabeledValueSummary label="INCOME STABILIZATION" value={getValueWithThousandSeperator(+incomeStabilization)} />}
                <OmLabeledValueSummary label="MONTHLY PREMIUM" value={monthlyPremium?`E ${monthlyPremium?.toFixed(2)} PM`:'-'} />
                <OmLabeledValueSummary label="ANNUAL PREMIUM" value={monthlyPremium?`E ${getValueWithThousandSeperator((monthlyPremium * 12)?.toFixed(2))} PA`:'-'} />
            </div>
        </OmEfpFamilyMemberCard>
    );
};

export default SizotsaFamilyMemberCard;
